import { Injectable, signal } from '@angular/core';

import { Toast, ToastType } from '../../shared/ui/toast/toast.model';

const AUTO_DISMISS_MS = 5000;

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly toastsState = signal<Toast[]>([]);

  readonly toasts = this.toastsState.asReadonly();

  success(message: string): void {
    this.push('success', message);
  }

  warning(message: string): void {
    this.push('warning', message);
  }

  error(statusCode: number | string, message?: string): void {
    this.push('error', message || 'Ocurrió un error. Intenta de nuevo.');
  }

  dismiss(id: string): void {
    this.toastsState.update((toasts) => toasts.filter((toast) => toast.id !== id));
  }

  private push(type: ToastType, message: string): void {
    const id = crypto.randomUUID();
    this.toastsState.update((toasts) => [...toasts, { id, type, message }]);
    setTimeout(() => this.dismiss(id), AUTO_DISMISS_MS);
  }
}
